import { LoadingStatus } from 'async-utils';
import { snapshot } from 'valtio';
import { calcDateRange } from '../../app/store-actions/top-bar-store-actions';
import TopBarStore from '../../app/stores/top-bar-store';
import { getAppOwnersStore } from '../../application-owners/api/applications-owners-api';
import { logSnackbarError } from '../../common/error-utils';
import { loadConnectorsByFamily } from '../../connectors/api/connectors-api';
import InventoryFiltersStore from '../../dashboard-inventory/stores/inventory-filters-store';
import {
  setSupplyChainItems,
  setSupplyChainLoadingStatus,
} from '../../executive-summary/store-actions/supply-chain-store-actions';
import ScanStore from '../../new-scan/store/scan-store';
import executiveService from '../services';
import { createConnectorsPanelData } from '../utils/supply-chain-connectors-utils';
import { createSupplyChainInfo } from '../utils/supply-chain-utils';

export const loadSupplyChain = async () => {
  try {
    const { filters } = snapshot(InventoryFiltersStore);
    const { displaySelectedAppOwners } = getAppOwnersStore();
    const { dateRange } = snapshot(TopBarStore);
    const [from, to] = calcDateRange(dateRange);
    const { scanID, isScanning, realScanId } = snapshot(ScanStore);

    setSupplyChainLoadingStatus(LoadingStatus.Pending);
    const result = await executiveService.getSupplyChain.execute(
      {
        dateRange: { from, to },
        ...(realScanId ? { scanId: realScanId } : scanID && { scanId: scanID }),
        owners: displaySelectedAppOwners,
        filters,
      },
      !isScanning,
    );

    if (result) {
      const connectorsByFamily = await loadConnectorsByFamily();
      const { connectorsPanelData } =
        createConnectorsPanelData(connectorsByFamily);

      const info = createSupplyChainInfo(result, connectorsPanelData);
      setSupplyChainItems(info);
    }
    setSupplyChainLoadingStatus(LoadingStatus.Success);
  } catch (err) {
    logSnackbarError('Failed to load supply chain info', err as Error);
    setSupplyChainLoadingStatus(LoadingStatus.Error);
  }
};
